import { z } from "zod";
import { RoleSchema } from "../../shared/schemas/role.schema.js";

export const TempAccessStatus = {
  Pending: "pending",
  Active: "active",
  Expired: "expired",
  Revoked: "revoked",
} as const;

export type TempAccessStatus = (typeof TempAccessStatus)[keyof typeof TempAccessStatus];

export const TempAccessStatusSchema = z.enum([
  TempAccessStatus.Pending,
  TempAccessStatus.Active,
  TempAccessStatus.Expired,
  TempAccessStatus.Revoked,
]);

const storedGrantShape = {
  id: z.string().min(1),
  orgId: z.string().min(1),
  orgName: z.string().min(1),
  role: RoleSchema,
  reason: z.string().min(3),
  status: TempAccessStatusSchema,
  requestedAt: z.iso.datetime(),
  grantedAt: z.iso.datetime().nullable(),
  expiresAt: z.iso.datetime().nullable(),
  revokedAt: z.iso.datetime().nullable(),
} as const;

export const StoredTempAccessGrantSchema = z.object(storedGrantShape).strict();

export type StoredTempAccessGrant = z.infer<typeof StoredTempAccessGrantSchema>;

export const TempAccessGrantSchema = z
  .object({
    ...storedGrantShape,
    userId: z.string().min(1),
    userEmail: z.email(),
  })
  .strict();

export type TempAccessGrant = z.infer<typeof TempAccessGrantSchema>;
